import { render, staticRenderFns } from "./CustomerListFilter.vue?vue&type=template&id=5b6c5f1f"
import script from "./CustomerListFilter.vue?vue&type=script&lang=ts"
export * from "./CustomerListFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports